"use strict";

exports.__esModule = true;
exports.UserListItem = UserListItem;
var _react = _interopRequireDefault(require("react"));
var _ListView = require("../../Core/ListView");
var _UserName = require("./UserName");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function UserListItem(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement(_ListView.ListItemView, null, /*#__PURE__*/_react["default"].createElement("h4", null, /*#__PURE__*/_react["default"].createElement(_UserName.UserName, {
    user: value
  })));
}